// NavBar.js - Componente modificato con posizione fissa
import React from 'react';
import { Home, Image, QrCode, User, Cookie } from 'lucide-react';

// Navigation Bar Component
const NavBar = ({ navigateTo, currentView }) => {
  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: '#27272a', /* bg-stone-800 equivalent */
      color: '#fef3c7', /* text-amber-100 equivalent */
      padding: '0.75rem 0',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.2)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-around'
      }}>
        <button 
          onClick={() => navigateTo('home')}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: currentView === 'home' ? '#fcd34d' : '#fef3c7'
          }}
        >
          <Home size={20} />
          <span style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>Home</span>
        </button>
        
        <button 
          onClick={() => navigateTo('gallery')}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: currentView === 'gallery' ? '#fcd34d' : '#fef3c7'
          }}
        >
          <Image size={20} />
          <span style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>Galleria</span>
        </button>
        
        <button 
          onClick={() => navigateTo('privacy')}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: currentView === 'privacy' ? '#fcd34d' : '#fef3c7'
          }}
        >
          <Cookie size={20} />
          <span style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>Privacy</span>
        </button>

        <button 
          onClick={() => navigateTo('myMemories')}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: currentView === 'myMemories' ? '#fcd34d' : '#fef3c7'
          }}
        >
          <User size={20} />
          <span style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>Ricordi</span>
        </button>
      </div>
    </nav>
  );
};

export default NavBar;